export default {
  tileTitle: {
    en: "Passport",ch: "護照",
    ja: "パスポート"
  },

  passport: {
    en: "Passport",ch: "護照",
    ja: "パスポート"
  },
  idCard: {
    en: "ID card",
    ja: "IDカード"
  },
  driverLicense: {
    en: "Driver’s License",
    ja: "運転免許証"
  },

  uploadMainPage: {
    en: "Upload main page",ch: "上傳主頁",
    ja: "メインページをアップロード"
  },
  uploadRegistrationPage: {
    en: "Upload registration page",ch: "上傳註冊頁面",
    ja: "登録ページをアップロード"
  },
  registrationPermit: {
    en: "Registration permit"
  }
}
